// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pi-5";
export var filledCircle = "_pi-4";
export var historyEntry = "_pi-3";
export var messageSideLeft = "_pi-1";
export var messageSideRight = "_pi-2";
export var orderTrackingCarouselWrapper = "_pi-6";
export var orderTrackingInfoContainer = "_pi-0";